__turbopack_context__.v({
  "addCartBtn": "ShopPageProductCard-module__K2jQ4G__addCartBtn",
  "card": "ShopPageProductCard-module__K2jQ4G__card",
  "cartIcon": "ShopPageProductCard-module__K2jQ4G__cartIcon",
  "cartLoadingText": "ShopPageProductCard-module__K2jQ4G__cartLoadingText",
  "colorRow": "ShopPageProductCard-module__K2jQ4G__colorRow",
  "imageArea": "ShopPageProductCard-module__K2jQ4G__imageArea",
  "imageLink": "ShopPageProductCard-module__K2jQ4G__imageLink",
  "infoArea": "ShopPageProductCard-module__K2jQ4G__infoArea",
  "labels": "ShopPageProductCard-module__K2jQ4G__labels",
  "navBtn": "ShopPageProductCard-module__K2jQ4G__navBtn",
  "newLabel": "ShopPageProductCard-module__K2jQ4G__newLabel",
  "nextBtn": "ShopPageProductCard-module__K2jQ4G__nextBtn",
  "noImage": "ShopPageProductCard-module__K2jQ4G__noImage",
  "normalPrice": "ShopPageProductCard-module__K2jQ4G__normalPrice",
  "oldPrice": "ShopPageProductCard-module__K2jQ4G__oldPrice",
  "prevBtn": "ShopPageProductCard-module__K2jQ4G__prevBtn",
  "priceActionBox": "ShopPageProductCard-module__K2jQ4G__priceActionBox",
  "priceBox": "ShopPageProductCard-module__K2jQ4G__priceBox",
  "priceCartBtn": "ShopPageProductCard-module__K2jQ4G__priceCartBtn",
  "priceRow": "ShopPageProductCard-module__K2jQ4G__priceRow",
  "priceSoldOutText": "ShopPageProductCard-module__K2jQ4G__priceSoldOutText",
  "productImage": "ShopPageProductCard-module__K2jQ4G__productImage",
  "productTitle": "ShopPageProductCard-module__K2jQ4G__productTitle",
  "quickViewBox": "ShopPageProductCard-module__K2jQ4G__quickViewBox",
  "rectangleImageLink": "ShopPageProductCard-module__K2jQ4G__rectangleImageLink",
  "rectangleProductImage": "ShopPageProductCard-module__K2jQ4G__rectangleProductImage",
  "reviewRow": "ShopPageProductCard-module__K2jQ4G__reviewRow",
  "reviewText": "ShopPageProductCard-module__K2jQ4G__reviewText",
  "saleLabel": "ShopPageProductCard-module__K2jQ4G__saleLabel",
  "salePrice": "ShopPageProductCard-module__K2jQ4G__salePrice",
  "squareImageLink": "ShopPageProductCard-module__K2jQ4G__squareImageLink",
  "squareProductImage": "ShopPageProductCard-module__K2jQ4G__squareProductImage",
  "stars": "ShopPageProductCard-module__K2jQ4G__stars",
  "stockLabel": "ShopPageProductCard-module__K2jQ4G__stockLabel",
  "swiper": "ShopPageProductCard-module__K2jQ4G__swiper",
  "wishlistBox": "ShopPageProductCard-module__K2jQ4G__wishlistBox",
});
